import React from 'react'

export default function FullDetails() {
  return (
    <div>FullDetails</div>
  )
}
